// App.js or any other component you wish to create the chart in
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Register the necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Barchart = ({cases, requests}) => {
  // Data for the chart
  const data = {
    labels: ['Cases', 'Requests'],  // Labels for the x-axis
    datasets: [
      { 
        label: 'Count',  // Label for the dataset
        data: [cases, requests],  // Data points (100 for Cases, 600 for Requests)
        backgroundColor: ['#ab00ff', '#5600ff'],  // Colors for the bars
        borderColor: ['#ab00ff', '#5600ff'],  // Border colors for the bars
        borderWidth: 1,
      }
    ]
  };

  // Options to customize the chart (optional)
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Comparison of Cases and Requests'
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,  // Ensures the y-axis starts at zero
        ticks: {
            stepSize:10,  // Controls the step size (spacing between numbers on y-axis)
            min: 0,          // Minimum value on the y-axis
            max: (requests > cases ? requests : cases),        // Maximum value on the y-axis (you can adjust it based on your data)
          }
      }
    }
  };

  return (
    <div style={{ width: '100%', margin: 'auto', height: '100%' }}>
      <Bar data={data} options={options} />
    </div>
  );
}

export default Barchart;
